import React from 'react'
import { graphql } from 'gatsby'

import { usePrismicPreviewPageData } from '../hooks/usePrismicPreviewPageData'
import { MapCustomTypeSlicesToComponents } from '../components/MapCustomTypeSlicesToComponents'
import { GenericTemplate } from '../components/GenericTemplate'

import { slicesMap } from 'src/slices/PageBody'

export const injectSlices = (list = []) => [
  { __typename: 'PageBodyHeader', id: 'header' },
  ...list,
  { __typename: 'PageBodyFooter', id: 'footer' },
]

export const PageTemplate = ({ children, data, location, ...props }) => {
  const mergedData = usePrismicPreviewPageData({
    data,
    location,
  })

  return (
    <GenericTemplate data={mergedData}>
      {children || (
        <MapCustomTypeSlicesToComponents
          data={mergedData}
          slicesMap={slicesMap}
          listMiddleware={injectSlices}
          {...props}
        />
      )}
    </GenericTemplate>
  )
}

export default PageTemplate

export const query = graphql`
  query($uid: String!) {
    prismicPage(uid: { eq: $uid }) {
      ...PageTemplate
    }
    ...SlicesPageBody
  }

  fragment PageTemplate on PrismicPage {
    ...PageParentRecursive
    uid
    data {
      title {
        text
      }
      meta_title
      meta_description
      body {
        __typename
      }
      main {
        __typename
      }
    }
  }
`
